/**
 * Request header the web app sends on every fetch to the API. The API exempts requests that carry
 * it from the "action nodes need a title" rule, because the Flow Designer adds blank nodes
 * and replays whole graphs (legacy untitled steps included) on undo/redo.
 */
export const WEB_CLIENT_HEADER = 'x-cofactor-client';
export const WEB_CLIENT_HEADER_VALUE = 'web';
